export default function Node_VsBrowser() {
  return <div>Node_VsBrowser Component</div>;
}
